let apiUrl = process.env.VUE_APP_API_STATIC;
let s3Url = process.env.VUE_APP_API_CC + "/getS3";
import { redirectToIndex } from "@/shared/redirectToIndex";
import { extractErrCode, normalizePayload } from "@/shared/responsePayload";
// process.env.NODE_ENV == "development"
//   ? "/static-config"
//   : process.env.VUE_APP_API_STATIC;

const redirectOnError = response => {
  if (response) {
    response.data = normalizePayload(response.data);
  }

  if (Number(extractErrCode(response && response.data)) === 999) {
    redirectToIndex("static-api-errCode-999", {
      url: response && response.config && response.config.url,
    });
  }
  return response;
};

export function getNews() {
  return axios.get(`${apiUrl}/main/news.json`).then(redirectOnError);
}

export function getMainEvents() {
  return axios
    .get(`${s3Url}?path=main/mainEvents.json`)
    .then(redirectOnError);
}

export function getEvent(eventId) {
  if (!eventId) {
    redirectToIndex("static-api-missing-event-id", { fn: "getEvent" });
    return Promise.resolve({ data: { errCode: "999", errDetail: "missing eventId" } });
  }
  return axios
    .get(`${s3Url}?path=event/${eventId}/event.json`)
    .then(redirectOnError);
}

export function getSessions(eventId) {
  if (!eventId) {
    redirectToIndex("static-api-missing-event-id", { fn: "getSessions" });
    return Promise.resolve({ data: { errCode: "999", errDetail: "missing eventId" } });
  }
  return axios
    .get(`${s3Url}?path=event/${eventId}/sessions.json`)
    .then(redirectOnError);
}

export function getProducts(eventId) {
  if (!eventId) {
    redirectToIndex("static-api-missing-event-id", { fn: "getProducts" });
    return Promise.resolve({ data: { errCode: "999", errDetail: "missing eventId" } });
  }
  return axios
    .get(`${s3Url}?path=event/${eventId}/products.json`)
    .then(redirectOnError);
}

export function getAreas(eventId) {
  if (!eventId) {
    redirectToIndex("static-api-missing-event-id", { fn: "getAreas" });
    return Promise.resolve({ data: { errCode: "999", errDetail: "missing eventId" } });
  }
  return axios
    .get(`${s3Url}?path=event/${eventId}/ticketAreas.json`)
    .then(redirectOnError);
}
